import MyAssets from './MyAssets.vue'

export default MyAssets
